import { render, staticRenderFns } from "./ContabilitaDocumentiEditPage.vue?vue&type=template&id=506be5cb&scoped=true"
import script from "./ContabilitaDocumentiEditPage.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentiEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506be5cb",
  null
  
)

export default component.exports